export const operationDetailsPageInitValue = {
  data: {
    operation: undefined,
    documents: [],
    partners: [],
    totalPartners: 0,
    page: 1,
    rowsPerPage: 10,
    isIndependentOperation: false,
    isOldOperation: false,
    isLoading: false,
  },
  actions: {
    fetchDocuments: () => {},
    handleChangePage: () => {},
    handleChangeRowsPerPage: () => {},
    handleOpenDividendModal: () => {},
    handleNotifyPartners: () => {},
    handleGenerateTaxDeclaration: async () => {},
    handleGenerateBankDocument: async () => {},
    handleGenerateTax193: async () => {},
    handleDownloadDividendFiscalDocument: async () => {},
    handleDownloadDividendRequestDocument: async () => {},
  },
};
